/** Identifiant Prysm'Analytics dans le catalogue Centre-Application (Admin → Applications). */
export const APPLICATION_ID_DEFAULT = '111d3383-ff87-4fd0-a268-c4519010a61f';

export function getApplicationId() {
  const fromEnv = process.env.REACT_APP_APPLICATION_ID?.trim();
  if (fromEnv) return fromEnv;
  return APPLICATION_ID_DEFAULT;
}
